<template>
  <div>
    <b-modal
      id="modalHistoricoCertificado"
      ref="modalHistoricoCertificado"
      size="xl"
      button-size="sm"
      no-close-on-backdrop
      no-stacking
      ok-only
      ok-title="Ok"
      :cancel-disabled="true"
      cancel-variant="false"
      scrollable
    >
      <div slot="modal-title">
        <h5>Histórico de Alterações - CERTIFICADO DIGITAL</h5>
        <fieldset class="font-weight-bold text-muted">
          Histórico de alterações dos certificados digitais
        </fieldset>
      </div>

      <b-row>
        <b-col>
          <b-table
            ref="tabelaHistorico"
            :items="historicoProvider"
            :fields="colunas"
            :current-page="currentPage"
            :per-page="perPage"
            responsive
            hover
            show-empty
            empty-text="Nenhum registro de alteração encontrado"
            class="text-nowrap"
          >
            <template #head(nomeRegistro)="data">
              <div style="min-width: 350px;">{{ data.label }}</div>
            </template>

            <template #head(alteradoEm)="data">
              <div style="min-width: 170px;">{{ data.label }}</div>
            </template>

            <template #cell(alteradoEm)="{ value }">
              {{ formatarData(value) }}
            </template>

            <template #cell(nomeRegistro)="{ value }">
              {{ value || '-' }}
            </template>

            <template #cell(campo)="{ item }">
              <b-badge variant="light-success">
                {{ formatarCampo(item.campo) }}
              </b-badge>
            </template>

            <template #cell(valorAntigo)="{ value }">
              {{ formatarValor(value) }}
            </template>

            <template #cell(valorNovo)="{ value }">
              {{ formatarValor(value) }}
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row v-if="totalRows > 0" class="mt-1 mb-1">
        <b-col>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
      <loading :is-loading="isLoading" />
    </b-modal>
  </div>
</template>

<script>
import api from '@/app/certificado-digital/shared/services/api'
import Loading from '@pilar/components/loading/Loading.vue'

const mapeamentoCampos = {
  nome: 'Nome do certificado',
  senha: 'Inclusão senha',
  porProcuracao: 'Por procuração',
  cadastroFederal: 'CNPJ/CPF',
  razaoSocial: 'Razão Social',
  vencimento: 'Vencimento',
  adicionado: 'Adição',
  excluido: 'Exclusão',
  renovacao: 'Renovação',
  renovado: 'Renovação',
}

export default {
  name: 'ModalHistoricoCertificado',
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: false,
      idsAtual: [],
      currentPage: 1,
      perPage: 50,
      totalRows: 0,
      colunas: [
        { key: 'alteradoEm', label: 'Data' },
        { key: 'nomeRegistro', label: 'Razão Social' },
        { key: 'alteradoPor', label: 'Usuário' },
        { key: 'campo', label: 'Campo' },
        { key: 'valorAntigo', label: 'De' },
        { key: 'valorNovo', label: 'Para' },
      ],
    }
  },
  computed: {},
  methods: {
    show(ids) {
      this.idsAtual = ids || []
      this.currentPage = 1
      this.$refs.modalHistoricoCertificado.show()
      if (this.$refs.tabelaHistorico) {
        this.$refs.tabelaHistorico.refresh()
      }
    },
    historicoProvider(ctx) {
      if (!this.idsAtual || this.idsAtual.length === 0) {
        this.totalRows = 0
        return []
      }
      this.isLoading = true
      return api.getHistoricoPaged(this.idsAtual, ctx.currentPage, ctx.perPage)
        .then(response => {
          const payload = response.data || response
          this.totalRows = payload.total || 0
          return payload.valores || []
        })
        .catch(() => {
          this.totalRows = 0
          return []
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    formatarData(dataString) {
      if (!dataString) return ''
      try {
        const data = new Date(dataString)
        const dia = String(data.getDate()).padStart(2, '0')
        const mes = String(data.getMonth() + 1).padStart(2, '0')
        const ano = data.getFullYear()
        const hora = String(data.getHours()).padStart(2, '0')
        const minuto = String(data.getMinutes()).padStart(2, '0')
        const segundo = String(data.getSeconds()).padStart(2, '0')
        return `${dia}/${mes}/${ano} ${hora}:${minuto}:${segundo}`
      } catch {
        return dataString
      }
    },
    formatarCampo(campo) {
      return mapeamentoCampos[campo] || campo
    },
    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') return 'Em branco'
      if (valor === true || valor === 'True' || valor === 'true') return 'Ativo'
      if (valor === false || valor === 'False' || valor === 'false') return 'Inativo'
      if (typeof valor === 'string' && valor.length > 0) {
        return valor.charAt(0).toUpperCase() + valor.slice(1)
      }
      return valor
    },
  },
}
</script>
